import {Component, Input, OnInit} from '@angular/core';
import {ViewCell} from 'ng2-smart-table';
import {EContactFieldType} from '../../../../@models';

@Component({
  selector: 'ngx-form-list-contact-field-render',
  template: '{{renderValue}}',
})
export class FormListContactFieldRenderComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

  ngOnInit() {
    this.renderValue = EContactFieldType[this.value];
  }
}
